import { useLightBox } from "contexts/lightBoxContext/lightBoxContext.js";
import { supportedPreviewFormats } from "./helpers.js";
import createPreview from "./createPreview.js";
import { useEffect } from "react";

const useLightboxOpenPreview = (file) => {
  const { setLightBox } = useLightBox();

  const fileType = supportedPreviewFormats.includes(file.type)
    ? file.type.includes("video")
      ? "Video"
      : file.type.includes("image")
      ? "Image"
      : null
    : null;

  const handleOpenLightbox = async () => {
    const preview = await createPreview(file, file.type);

    fileType &&
      setLightBox(fileType, null, {
        PreviewSrc: preview,
        Name: file.name,
        Type: fileType,
      });
  };

  return { handleOpenLightbox };
};
export default useLightboxOpenPreview;
